/**
 * Actycrea: language-banner.esm.js (ES6)
 * MIT
 */
import { PREFIX } from '../helpers/config.js';
import { getCookie, setCookie } from '../helpers/helpers.js';

const SELECTOR      = `data-${PREFIX}-language-banner`;
const SELECTOR_DATA = `[${SELECTOR}]`;
const COOKIE_NAME    = 'wam_lang_banner_dismissed';
const COOKIE_DAYS    = 30;

// Textos del banner según el idioma de DESTINO ofrecido (no el idioma
// actual de la página), para que el mensaje siempre invite en el idioma
// al que se está sugiriendo cambiar. 'en' actúa también como fallback.
const COPY = {
  es: {
    text: 'Esta página también está disponible en %s.',
    go:   'Ver en %s',
  },
  en: {
    text: 'This page is also available in %s.',
    go:   'View in %s',
  },
};

export class LanguageBanner {
  /**
   * @param {HTMLElement} element – contenedor del banner
   */
  constructor( element ) {
    if ( !( element instanceof HTMLElement ) ) throw new Error( 'LanguageBanner: element inválido' );

    this._element  = element;
    this._goLink   = element.querySelector( '.language-banner-go' );
    this._closeBtn = element.querySelector( '.language-banner-close' );
    this._textEl   = element.querySelector( '.language-banner-text' );

    this._onClose = this._onClose.bind( this );
    if ( this._closeBtn ) this._closeBtn.addEventListener( 'click', this._onClose, false );

    this._init();
  }

  _init() {
    if ( getCookie( COOKIE_NAME ) ) return;

    const data = ( window.wphack && window.wphack.language_banner ) || null;
    if ( !data || !data.current || !data.translations ) return;

    const browserLang = ( navigator.language || navigator.userLanguage || '' ).split( '-' )[ 0 ].toLowerCase();
    if ( !browserLang || browserLang === data.current ) return;

    const target = data.translations[ browserLang ];
    if ( !target || !target.url ) return;

    const copy = COPY[ browserLang ] || COPY.en;

    if ( this._goLink ) {
      this._goLink.setAttribute( 'href', target.url );
      const textEl = this._goLink.querySelector( '.text' );
      if ( textEl ) textEl.textContent = copy.go.replace( '%s', target.name );
    }

    if ( this._textEl ) {
      this._textEl.textContent = copy.text.replace( '%s', target.name );
    }

    this._element.removeAttribute( 'hidden' );
  }

  _onClose( evt ) {
    evt.preventDefault();
    setCookie( COOKIE_NAME, '1', COOKIE_DAYS );
    this._element.setAttribute( 'hidden', '' );
  }

  /* ============
   * Init masiva
   * ===========*/
  static initAll( root = document ) {
    const nodes = root.querySelectorAll( SELECTOR_DATA );
    const instances = [ ];
    nodes.forEach( ( el ) => {
      if ( el._languageBannerInstance ) return;
      el._languageBannerInstance = new LanguageBanner( el );
      instances.push( el._languageBannerInstance );
    } );
    return instances;
  }
}

export default LanguageBanner;
